import './all-external-dependencies'
import posthog from './module.es'
export * from './module.es'
export default posthog
